import { makeStyles } from "@material-ui/core";

export const UseStablishmentsStyles = makeStyles((theme) => ({
  establishmentName: {
    color: theme.palette.grey[900],
  },
}));
